import { render } from "./signup.vue?vue&type=template&id=0e806920"
import script from "./signup.js?vue&type=script&lang=js&external"
export * from "./signup.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__